import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasicTreeTooltipComponent } from './basic-tree-tooltip.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        MatProgressSpinnerModule,
    ],
    declarations: [
        BasicTreeTooltipComponent,
    ],
    exports: [
        BasicTreeTooltipComponent,
    ],
})
export class BasicTreeTooltipModule {}
